import { render, staticRenderFns } from "./CompanyAdd.form.vue?vue&type=template&id=4f80f09c&scoped=true&"
import script from "./CompanyAdd.form.vue?vue&type=script&lang=js&"
export * from "./CompanyAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80f09c",
  null
  
)

export default component.exports